import { loadAsyncComponent } from 'src/components/AsyncComponent';

export default loadAsyncComponent(
  () => import(/* webpackChunkName: "NotVerifiedPage" */ './Container'),
  'page'
);
